import ProgramParticipantsContainer from './program_participants_container';

const ProgramParticipants = ProgramParticipantsContainer;
export default ProgramParticipants;
